const StringMask = require('string-mask');

export function formatBrl(n: number) {
  const num = n.toFixed(2).split('.');
  num[0] = 'R$ ' + num[0].split(/(?=(?:...)*$)/).join('.');
  return num.join(',').replace('.,', ',');
}

export function setMask(mask: string, newVal: any, oldVal?: any) {
  oldVal = oldVal || newVal;

  let onlyNumbers = false;
  let withZero = false;
  let reverse = false;
  const isBackspace = newVal.length < oldVal.length;

  switch (mask) {
    case 'cpf':
      mask = '000.000.000-00';
      onlyNumbers = true;
      withZero = true;
      break;
    case 'cnpj':
      mask = '00.000.000/0000-00';
      onlyNumbers = true;
      break;
    case 'date':
      mask = '00/00/0000';
      onlyNumbers = true;
      withZero = true;
      break;
    case 'time':
      mask = '00:00';
      onlyNumbers = true;
      break;
    case 'tel':
      mask = '(00) 0000-0000';
      onlyNumbers = true;
      break;
    case 'cel':
      mask = '(00) 00000-0000';
      onlyNumbers = true;
      break;
    case 'cep':
      mask = '00000-000';
      onlyNumbers = true;
      break;
    case 'num':
      mask = '0000000000';
      onlyNumbers = true;
      break;
    case 'real':
      mask = 'R$ ###.###.##0,00';
      reverse = true;
      onlyNumbers = true;
      break;
    case 'kg':
      mask = '########0.000';
      reverse = true;
      onlyNumbers = true;
      break;
    case 'placa':
      mask = '0000-0000';
      withZero = true;
      onlyNumbers = true;
      break;
  }

  // REMOVE A MASK E ZEROS SE FOR APENAS NÚMEROS
  if (onlyNumbers) {
    newVal = newVal.match(/\d/g);
    newVal = newVal == null ? '' : newVal.join('');
    newVal = withZero ? newVal : '' + parseInt(newVal, 10);
    newVal = isNaN(newVal) ? '' : newVal;
  }

  // APLICA A MÁSCARA
  newVal = StringMask.apply(newVal, mask, { reverse });

  // RESOLVE O PROBLEMA DE APAGAR E MANTER
  if (isBackspace && isNaN(parseInt(oldVal.slice(-1)))) {
    newVal = newVal.substring(0, newVal.length - 1);
  }

  // RESOLVE BUG AO APAGAR TELEFONES
  if (
    isBackspace &&
    isNaN(parseInt(oldVal.slice(-1))) &&
    isNaN(parseInt(oldVal.slice(-2)))
  ) {
    newVal = newVal.substring(0, newVal.length - 2);
  }

  // RETORNA O NOVO VALOR COM A MÁSCARA
  return newVal;
}

export const applyMaskOnChange = (mask: string) => (e: any) => {
  e.target.value = setMask(mask, e.target.value);
};

export const removeMaskIfBackspace = (e: any) => {
  if (e.key === 'Backspace') {
    e.target.value = e.target.value.replace(/\D+/g, '');
  }
};

function renameKey(obj: any, old_key: any, new_key: any) {
  if (old_key !== new_key) {
    Object.defineProperty(
      obj,
      new_key,
      Object.getOwnPropertyDescriptor(obj, old_key) as any
    );
    delete obj[old_key];
  }
}

export function rename(data: any, prop: any, newProp: any) {
  data.forEach((obj: any) => renameKey(obj, prop, newProp));
}
